import { Autocomplete, Stack, TextField } from '@material-ui/core';
import { useState } from 'react';
import * as Yup from 'yup';

export default function InnerForm({ index, setValue, value }) {
  // const NewUserSchema = Yup.object().shape({
  //   noOfSegment: Yup.number().required('*Please enter greater number')
  // });

  const top100Films = ['Client1', 'Client2', 'Client3'];
  //   const id = [parseInt(1 + Math.random() * (1000 - 1), 10)];
  // const [value, setValue] = useState({});

  const handleSecondTextFieldChange = (e, secondIndex, nextFirstIndex) => {
    // console.log('e.target.value', parseInt(e.target.value, 10));
    console.log('secondIndex', secondIndex);
    console.log('nextFirstIndex', nextFirstIndex);
    // setValue({ ...value });
    let tempVal = 0;
    if (e.target.value) {
      tempVal = e.target.value;
    }
    setValue({
      ...value,
      [nextFirstIndex]: parseInt(tempVal, 10) + 1,
      [secondIndex]: parseInt(tempVal, 10)
    });
  };

  const newIndex = index + 1;

  return (
    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} sx={{ marginTop: 2 }}>
      <TextField fullWidth value={value[`${newIndex}1`]} disabled />
      <TextField
        fullWidth
        label={`Bucket ${newIndex}`}
        value={value[`${newIndex}2`]}
        onChange={(event) => handleSecondTextFieldChange(event, `${newIndex}2`, `${newIndex + 1}1`)}
        disabled={!(value[`${newIndex}1`] >= 0)}
        error={Boolean(parseInt(value[`${newIndex}2`], 10) <= parseInt(value[`${newIndex}1`], 10))}
        helperText={
          parseInt(value[`${newIndex}2`], 10) <= parseInt(value[`${newIndex}1`], 10)
            ? `Value should be greater than ${value[`${newIndex}1`]}`
            : ''
        }
      />
      {/* <Autocomplete
        fullWidth
        options={top100Films}
        getOptionLabel={(option) => option}
        renderInput={(params) => <TextField fullWidth {...params} label="Map column/Header" />}
      /> */}
    </Stack>
  );
}
